import { createRoute } from "@tanstack/react-router";

import { root } from "routes";

import Layout from "theme/ui/Layout";

import { query } from "areas/home/data";
import Home from "./pages/Home";
import FAQ from "./pages/FAQ";


const _root = createRoute({
	getParentRoute: () => root,
	id: "home-layout",
	component: () => <Layout.Dark />
});

const index = createRoute({
	getParentRoute: () => _root,
	path: "/",
	loader: async ({ context }) => {
		const { queryClient, user } = context;
		if (user) {
			Promise.allSettled([
				queryClient.ensureQueryData(query.top.day),
				queryClient.ensureQueryData(query.top.week)
			]);
		}
		else queryClient.ensureQueryData(query.top.featured);
	},
	component: () => <Home />,
	staticData: {
		footer: "default"
	}
});

const faq = createRoute({
	getParentRoute: () => _root,
	path: "faq",
	component: () => <FAQ />,
	staticData: {
		footer: "default"
	}
});

const home = _root.addChildren([index, faq]);
export default home;